import _ from "lodash";
import React, { useCallback, useMemo } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import {
  GenericIntegrationTicketDefaultValues,
  GenericIntegrationTicketSystemListingProps,
} from "../genericIntegrationTicketConstants";

function VersionOneIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns.map((col: any) => {
      // Version One gets projectKey and issueType value from custom field since an earlier implementation
      if (col.dataIndex === "projectKey") {
        col.showFilter = false;
        col.showSort = false;
        col.render = (
          projectKey: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const project = _.find(
            record.customFields,
            (field) => field.key === "projectValue",
          );
          return CellRenderers.VALUE_OR_NA(project?.name || projectKey);
        };
      }
      if (col.dataIndex === "issueType") {
        col.render = (
          issueType: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const _issueType = record.customFields
            ? _.find(
                record.customFields,
                (field) => field.key === "issueTypeValue",
              )?.name
            : issueType;
          return CellRenderers.VALUE_OR_NA(_issueType);
        };
      }
      return col;
    });
    return updatedColumns;
  }, []);

  const extraColumns = useMemo(() => {
    return [
      {
        title: "Team",
        dataIndex: "team",
        width: 100,
        render: (
          team: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const _team = record.customFields
            ? _.find(record.customFields, (field) => field.key === "teamValue")
                ?.name
            : "";
          return CellRenderers.VALUE_OR_NA(_team);
        },
      },
    ];
  }, []);

  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        extraColumns={extraColumns}
        {...props}
      />
    </div>
  );
}

export default VersionOneIntegrationListing;
